import React, { useEffect, useState } from "react";
import { Alert, Button, ProgressBar } from "react-bootstrap";
import { BsFillPersonPlusFill } from "react-icons/bs";
import api from "../../../../Utils/api";

function AddPolicial({ boletim, setBoletim }) {
  const formDraft = boletim.formDrafts?.efetivo || {};
  const [vtr, setVtr] = useState(formDraft.vtr || "");
  const [nome, setNome] = useState(formDraft.nome || "");
  const [graduacao, setGraduacao] = useState(formDraft.graduacao || "");
  const [numeroBarra, setNumeroBarra] = useState(formDraft.numeroBarra || "");
  const [id, setId] = useState(formDraft.id || "");
  const [error, setError] = useState('');

  useEffect(() => {
    setBoletim((current) => ({
      ...current,
      formDrafts: {
        ...current.formDrafts,
        efetivo: { vtr, nome, graduacao, numeroBarra, id },
      },
    }));
  }, [vtr, nome, graduacao, numeroBarra, id, setBoletim]);

  const resetaCampos = () => {
    setVtr("");
    setNome("");
    setGraduacao("");
    setNumeroBarra("");
    setId("");
  };

  const buscarUsuario = async () => {

    if (!id) return; // Não buscar se o ID estiver vazio
    try {
      const { data } = await api.get(`/user/${encodeURIComponent(id)}`);
      
      const user = data?.[0];
      if (user) {
        setNome(user.userName);
        setNumeroBarra(user.userBarra);
        setGraduacao(user.userGraduacao);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const addPolicial = (e) => {
    e.preventDefault();
    if (!id.trim() || !nome.trim() || !vtr.trim()) {
      setError('Informe matrícula, nome e VTR do policial.');
      return;
    }
    if ((boletim.efetivo || []).some(item => String(item.id).trim() === id.trim())) {
      setError('Este policial já está no efetivo. Edite o integrante existente.');
      return;
    }
    setError('');

    setBoletim((current) => ({
      ...current,
      efetivo: (current.efetivo || []).some(item => String(item.id).trim() === id.trim())
        ? current.efetivo : [...(current.efetivo || []), { id: id.trim(), nome: nome.trim(), graduacao, numeroBarra, vtr }],
      formDrafts: { ...current.formDrafts, efetivo: {} },
    }));

    resetaCampos();
  };

  return (
    <div className="bo-section">
      <ProgressBar now={80} className="bo-progress" />

      <div className="bo-section-title">Efetivo Policial</div>
      {error && <Alert variant="danger" role="alert">{error}</Alert>}

      <form onSubmit={addPolicial}>
        <div className="bo-field">
          <label>Prefixo da VTR</label>
          <input
            placeholder="Ex: 128"
            value={vtr}
            required
            onChange={(e) => setVtr(e.target.value)}
          />
        </div>

        <div className="bo-field">
          <label>Matrícula / ID</label>
          <input
            type="text"
            inputMode="numeric"
            placeholder="ID"
            value={id}
            required
            onBlur={buscarUsuario}
            onChange={(e) => setId(e.target.value)}
          />
        </div>

        <div className="bo-field">
          <label>Posto / Graduação</label>
          <input
            placeholder="Ex: SD"
            value={graduacao}
            onChange={(e) => setGraduacao(e.target.value)}
          />
        </div>

        <div className="bo-field">
          <label>Número / Barra</label>
          <input
            placeholder="000/18"
            value={numeroBarra}
            onChange={(e) => setNumeroBarra(e.target.value)}
          />
        </div>

        <div className="bo-field">
          <label>Nome do Policial</label>
          <input
            placeholder="Nome completo"
            value={nome}
            required
            onChange={(e) => setNome(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-center mt-3">
        <Button type="submit" variant="warning">
          <BsFillPersonPlusFill /> Adicionar Policial
        </Button>
        </div>
      </form>
    </div>
  );
}

export default AddPolicial;
